// changes S-31 surface item 
$(function () {
    $('.surfaced-item-with-bgcolor').each(function () {
        var showMoreBtn,
            text,
            mask,
            expandBtn,
            collapseBtn;
        showMoreBtn = $(this).find('.truncate-btn');
        text = $(this).find('.surfaced-item-description');
        mask = $(this).find('.mask-gradient');
        expandBtn = $(this).find('.expand-btn');
        collapseBtn = $(this).find('.collapse-btn');
        if (showMoreBtn.length > 0) {
            if ($(window).width() < 480 && $(text).height() > 73) {
                if ($(showMoreBtn).is(':empty')) {
                    $(text).css("height", 'auto');
                }
                else {
                    $(text).css("height", 65);
                }
                $(collapseBtn).css("display", "none");
                $(expandBtn).on('click', function () {
                    $(text).css("height", 'auto');
                    $(mask).css("display", "none");
                    $(collapseBtn).css("display", "inline-block");
                    $(expandBtn).css("display", "none");
                });
                $(collapseBtn).on('click', function () {
                    $(text).css("height", 65);
                    $(mask).css("display", "block");
                    $(collapseBtn).css("display", "none");
                    $(expandBtn).css("display", "inline-block");
                });
            } else if ($(text).height() === 65) {
                return;
            } else {
                $(showMoreBtn).css("display", "none");
                $(mask).css("display", "none");
            }
        }
    });
});